import { Identifiable, Project, ProjectExternalLink } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function extractList(data: { [key: string]: string }) {
  return JSON.parse(data.externalLinks || "[]");
}

function pushLink(link: ProjectExternalLink, list: ProjectExternalLink[]) {
  return JSON.stringify({
    ...list,
    [link.index]: link,
  });
}

function saveProjectExternalLink(httpClient: HttpClient) {
  return ({ uuid }: Identifiable<Project>, link: ProjectExternalLink) =>
    httpClient
      .sendHttpRequest<Identifiable<Project>>({
        endpoint: `/projects/${uuid}`,
        method: HttpMethods.GET,
      })
      .then((project) =>
        httpClient.sendHttpRequest<void>({
          endpoint: `/projects/${project.uuid}`,
          method: HttpMethods.PATCH,
          data: {
            data: {
              externalLinks: pushLink(link, extractList(project.data)),
            },
          },
        }),
      );
}

export { saveProjectExternalLink };
